import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { useCompanyConfigQuery } from "../../SWR/Company/useCompanyConfigQuery";
import { ActionTypes } from "./OrderFlowActionTypes";
import { OrderFlowReducer } from "./OrderFlowReducer";
import { DEFAULT_CART } from "./defaultCart";
import { DEFAULT_MODEL } from "./defaultModel";
import { buildMealAndProductDictionaries } from "./mealAndProductDictionaries";
const initialState = {
    cart: DEFAULT_CART,
    model: DEFAULT_MODEL,
};
export const OrderFlowProvider = ({ children }) => {
    const { startSunday } = useCompanyConfigQuery();
    const [store, dispatch] = React.useReducer((store, action) => OrderFlowReducer(store, action, startSunday), initialState);
    // TODO REPLACE AND REMOVE ALL INSTANCES OF AND REFERENCES TO pricingBreakdown WITH EQUIVALENT FROM BALANCE OBJECT
    const [pricingBreakdown, setPricingBreakdown] = useState();
    const [balance, setBalance] = useState();
    // We don't set these to state because they should be static and should not change.
    const { programMealDictionary, productDictionary } = buildMealAndProductDictionaries(store.model.Program.ProgramMeals, store.model.Products);
    const resetContext = () => {
        dispatch({
            type: ActionTypes.SET_CART,
            payload: DEFAULT_CART,
        });
        dispatch({
            type: ActionTypes.SET_MODEL,
            payload: DEFAULT_MODEL,
        });
    };
    return (_jsx(OrderFlowContext.Provider, Object.assign({ value: {
            store,
            dispatch,
            // TODO REPLACE AND REMOVE ALL INSTANCES OF AND REFERENCES TO pricingBreakdown WITH EQUIVALENT FROM BALANCE OBJECT
            pricingBreakdown,
            setPricingBreakdown,
            balance,
            setBalance,
            programMealDictionary,
            productDictionary,
            resetContext,
        } }, { children: children })));
};
export const OrderFlowContext = React.createContext({
    store: initialState,
    dispatch: () => { },
    // TODO REPLACE AND REMOVE ALL INSTANCES OF AND REFERENCES TO pricingBreakdown WITH EQUIVALENT FROM BALANCE OBJECT
    pricingBreakdown: undefined,
    setPricingBreakdown: () => { },
    balance: undefined,
    setBalance: () => { },
    programMealDictionary: undefined,
    productDictionary: undefined,
    resetContext: () => { },
});
export const useOrderFlow = () => React.useContext(OrderFlowContext);
